export const DEFAULT_TOAST_TIMEOUT = 5000;
export const DEFAULT_TOOLTIP_DELAY = 500;
export const SHORT_SETTLE_DELAY = 1000;
